import DatoLink from '@/components/DatoLink/DatoLink'
import { cn } from '@desoutter/uikit'
import Image from 'next/image'
import { Image as DatoImage } from 'react-datocms'
import { DatoLinkFragment } from '@/components/DatoLink/DatoLink.generated'
import { PagelinksImagesCardFragment } from '@/components/blocks/PagelinksImagesBlock/PagelinksImagesCard/PagelinksImagesCard.generated'

export function MenuCardsMinimal({
	card,
}: {
	card: PagelinksImagesCardFragment
}) {
	return (
		<div
			key={card.id}
			className={cn('h-40 relative group overflow-clip rounded-lg')}
		>
			<DatoLink fragment={card.link as DatoLinkFragment}>
				<Image
					src="/images/linear-mask.png"
					alt="linear-mask"
					fill
					style={{ objectFit: 'cover' }}
					className="absolute bottom-0 w-full z-10 group-hover:brightness-125 duration-200"
				/>
				<DatoImage
					data={card.image?.responsiveImage}
					layout="fill"
					objectFit="cover"
					className="group-hover:scale-105 duration-200"
				/>
				<div
					className={cn(
						'text-white absolute bottom-0 left-0 p-2 z-20',
						'group-hover:-translate-y-2 duration-200',
					)}
				>
					{card.title}
				</div>
			</DatoLink>
		</div>
	)
}
